import React from "react";
import { UserShortInfo } from "../../types";

const ShortManInfo = (props: UserShortInfo) => {
  const { photo, name, phone } = props;
  return (
    <div className="userShortInfo">
      <div className="userPhoto">
        <img src={photo?.replace("uploads", "/files") || "/images/def_avatar_icon.png" } alt="User" />
      </div>
      <div className="userDetails">
        <div className="userName">{name}</div>
        <div className="userPhone">{phone}</div>
      </div>
    </div>
  );
};

export default ShortManInfo;